export default "__VITE_ASSET__ed1f39b3__"